/*global require: false */
require(['jquery', 'core'], function ($) {
    'use strict';

    // Ensure below conditions are met for the counters to work
    // 1) TextArea element should have the class "counter"
    // 2) TextArea element should have the attribute "maxlength" with a value specified
    // 3) There should be a span element with ID = ID of TextArea + "Counter"
    // Sample HTML  
    // <textarea id="comments" class="counter" maxlength="100"></textarea>
    // <span id="commentsCounter"></span>
    // TO DO - Create a HTML helper that would spit out the TextArea and Span combo with all the above conditions

    $('textarea.counter').keyup(function () {        

        // Get the id of textarea
        var $textAreaID = $(this).attr('id');

        // Get count the number of characters in the current text inside the textarea  
        var $length = $(this).val().length;

        // Get the limit from maxlength attribute  
        var $textAreaMaxLength = parseInt($(this).attr('maxlength'));        

        var $counterSpan = $("span[id*='" + $textAreaID + "Counter'");

        if ($counterSpan.length) {

            // Get the count of remaining characters that user can type
            var $remainingCharLength = $textAreaMaxLength - $length;

            var $message = $remainingCharLength + ' characters remaining';

            $("span[id*='" + $textAreaID + "Counter'").text($message);
        }
    });

    $('textarea.counter').keypress(function (e) {
        var code = e.keyCode || e.which;

        if (code == 13) {
            return false;
        }
    });

    function $setCounters() {
        // Find all the textarea with counters
        $("textarea.counter").each(function () {
            // Get the id of textarea
            var $textAreaID = $(this).attr('id');

            // Get count the number of characters in the current text inside the textarea  
            var $length = $(this).val().length;

            // Get the limit from maxlength attribute  
            var $textAreaMaxLength = parseInt($(this).attr('maxlength'));

            var $counterSpan = $("span[id*='" + $textAreaID + "Counter'");

            if ($counterSpan.length) {

                // Get the count of remaining characters that user can type
                var $remainingCharLength = $textAreaMaxLength - $length;
                
                var $message = $remainingCharLength + ' characters remaining';

                $("span[id*='" + $textAreaID + "Counter'").text($message);
            }
        });
    }

    $setCounters();
});
define("characters-countdown", function(){});

